import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M11.8733 6.58331H6.93328V11.5233H5.28662V6.58331H0.346619V4.93664H5.28662V-0.00335693H6.93328V4.93664H11.8733V6.58331Z",
	fill: "white"
}));
export default SvgPlus;
